var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatWithWashmen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7295_17952)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.5 38C28.7173 38 37 29.4934 37 19C37 8.50659 28.7173 0 18.5 0C8.28273 0 0 8.50659 0 19C0 29.4934 8.28273 38 18.5 38Z",
    fill: "#00A368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9.75C23.0041 9.75 26.25 12.9959 26.25 17V17.418C26.8412 17.6988 27.25 18.3019 27.25 19V22C27.25 22.6981 26.8412 23.3012 26.25 23.582V24C26.25 26.0437 24.6152 27.7054 22.582 27.749C22.3013 28.3407 21.6984 28.75 21 28.75H19C18.0335 28.75 17.25 27.9665 17.25 27V26.5C17.25 25.5335 18.0335 24.75 19 24.75H21C21.8775 24.75 22.6041 25.3959 22.7305 26.2383C23.8648 26.1228 24.75 25.1648 24.75 24V23.75H24.5C23.5335 23.75 22.75 22.9665 22.75 22V19C22.75 18.0335 23.5335 17.25 24.5 17.25H24.75V17C24.75 13.8244 22.1756 11.25 19 11.25C15.8244 11.25 13.25 13.8244 13.25 17V17.25H13.5C14.4665 17.25 15.25 18.0335 15.25 19V22C15.25 22.9665 14.4665 23.75 13.5 23.75H12.5C11.5335 23.75 10.75 22.9665 10.75 22V19C10.75 18.3019 11.1588 17.6988 11.75 17.418V17C11.75 12.9959 14.9959 9.75 19 9.75ZM19 26.25C18.8619 26.25 18.75 26.3619 18.75 26.5V27C18.75 27.1381 18.8619 27.25 19 27.25H21C21.1381 27.25 21.25 27.1381 21.25 27V26.5C21.25 26.3619 21.1381 26.25 21 26.25H19ZM12.5 18.75C12.3619 18.75 12.25 18.8619 12.25 19V22C12.25 22.1381 12.3619 22.25 12.5 22.25H13.5C13.6381 22.25 13.75 22.1381 13.75 22V19C13.75 18.8619 13.6381 18.75 13.5 18.75H12.5ZM24.5 18.75C24.3619 18.75 24.25 18.8619 24.25 19V22C24.25 22.1381 24.3619 22.25 24.5 22.25H25.5C25.6381 22.25 25.75 22.1381 25.75 22V19C25.75 18.8619 25.6381 18.75 25.5 18.75H24.5Z",
    fill: "#00A368"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7295_17952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithWashmen);
export default __webpack_public_path__ + "static/media/chat-with-washmen.a3c6fcb5fa10599050d6c116445322ef.svg";
export { ForwardRef as ReactComponent };